"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\guest-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var paho_mqtt_1 = require("../../clients/paho-mqtt");

var pb_1 = require("./pb");

var ExtendedGuestChatDecline =
/*#__PURE__*/
function (_pb_1$GuestChatDeclin) {
  _inherits(ExtendedGuestChatDecline, _pb_1$GuestChatDeclin);

  function ExtendedGuestChatDecline(properties) {
    var _this;

    _classCallCheck(this, ExtendedGuestChatDecline);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ExtendedGuestChatDecline).call(this, properties));
    _this.type = ExtendedGuestChatDecline.type;
    _this.chreqid = properties.request.proxy.chreqid;
    return _this;
  }

  _createClass(ExtendedGuestChatDecline, [{
    key: "toMQTT",
    value: function toMQTT() {
      var topic = "".concat(this.request.proxy.property).concat(ExtendedGuestChatDecline.context);
      var mqttMessage = new paho_mqtt_1.Message(pb_1.GuestChatDecline.encode(this).finish());
      mqttMessage.destinationName = topic;
      mqttMessage.qos = 1;
      return mqttMessage;
    }
  }], [{
    key: "fromMQTT",
    value: function fromMQTT(mqttMessage) {
      return new ExtendedGuestChatDecline(pb_1.GuestChatDecline.decode(mqttMessage.payloadBytes));
    }
  }]);

  return ExtendedGuestChatDecline;
}(pb_1.GuestChatDecline);

ExtendedGuestChatDecline.type = "GuestChatDecline";
ExtendedGuestChatDecline.context = "/guest-chat/decline";
exports.GuestChatDecline = ExtendedGuestChatDecline;